import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';

import { AggregatedStatus, Installation, InstallationItem } from '@vi-iot/client';

export namespace InstallationsActions {
  export enum Type {
    LIST_FIRST_THOUSAND_INSTALLATIONS = '[INSTALLATIONS] List first thousand Installations',
    LIST_FIRST_THOUSAND_INSTALLATIONS_SUCCESS = '[INSTALLATIONS] List first thousand Installations Success',
    LIST_FIRST_THOUSAND_INSTALLATIONS_ERROR = '[INSTALLATIONS] List first thousand Installations Error',
    LIST_SECOND_THOUSAND_INSTALLATIONS = '[INSTALLATIONS] List second thousand Installations',
    LIST_SECOND_THOUSAND_INSTALLATIONS_SUCCESS = '[INSTALLATIONS] List second thousand Installations Success',
    LIST_SECOND_THOUSAND_INSTALLATIONS_ERROR = '[INSTALLATIONS] List second thousand Installations Error',
    LIST_THIRD_THOUSAND_INSTALLATIONS = '[INSTALLATIONS] List third thousand Installations',
    LIST_THIRD_THOUSAND_INSTALLATIONS_SUCCESS = '[INSTALLATIONS] List third thousand Installations Success',
    LIST_THIRD_THOUSAND_INSTALLATIONS_ERROR = '[INSTALLATIONS] List third thousand Installations Error',
    LIST_LOCKED_INSTALLATIONS = '[INSTALLATIONS] List Locked Installations',
    LIST_LOCKED_INSTALLATIONS_SUCCESS = '[INSTALLATIONS] List Locked Installations Success',
    LIST_LOCKED_INSTALLATIONS_ERROR = '[INSTALLATIONS] List Locked Installations Error',
    REMOVE_INSTALLATION = '[INSTALLATIONS] Remove Installation',
    DEREGISTER_INSTALLATION = '[INSTALLATIONS] Deregister Installation',
    DEREGISTER_INSTALLATION_SUCCESS = '[INSTALLATIONS] Deregister Installation Success',
    DEREGISTER_INSTALLATION_ERROR = '[INSTALLATIONS] Deregister Installation Error',
    RESET_DEREGISTER_STATE = '[INSTALLATIONS] Reset Deregister State',
    LIVE_UPDATE_AGGREGATED_STATUS = '[INSTALLATIONS] Live Update Aggregated Status',
    OMIT_LOADING_REMOTE_SERVICE_SUMMARIES = '[INSTALLATIONS] Omit Loading Remote Service Summaries',
  }

  export const listFirstThousandInstallations = createAction(
    Type.LIST_FIRST_THOUSAND_INSTALLATIONS
  );

  export const listFirstThousandInstallationsSuccess = createAction(
    Type.LIST_FIRST_THOUSAND_INSTALLATIONS_SUCCESS,
    props<{
      installations: InstallationItem[];
      cursor?: string;
    }>()
  );

  export const listFirstThousandInstallationsError = createAction(
    Type.LIST_FIRST_THOUSAND_INSTALLATIONS_ERROR,
    props<{ error: any }>()
  );

  export const listSecondThousandInstallations = createAction(
    Type.LIST_SECOND_THOUSAND_INSTALLATIONS,
    props<{
      cursor: string;
    }>()
  );

  export const listSecondThousandInstallationsSuccess = createAction(
    Type.LIST_SECOND_THOUSAND_INSTALLATIONS_SUCCESS,
    props<{
      installations: InstallationItem[];
      cursor?: string;
    }>()
  );

  export const listSecondThousandInstallationsError = createAction(
    Type.LIST_SECOND_THOUSAND_INSTALLATIONS_ERROR,
    props<{ error: any }>()
  );

  export const listThirdThousandInstallations = createAction(
    Type.LIST_THIRD_THOUSAND_INSTALLATIONS,
    props<{
      cursor: string;
    }>()
  );

  export const listThirdThousandInstallationsSuccess = createAction(
    Type.LIST_THIRD_THOUSAND_INSTALLATIONS_SUCCESS,
    props<{
      installations: InstallationItem[];
    }>()
  );

  export const listThirdThousandInstallationsError = createAction(
    Type.LIST_THIRD_THOUSAND_INSTALLATIONS_ERROR,
    props<{ error: any }>()
  );

  export const listLockedInstallations = createAction(Type.LIST_LOCKED_INSTALLATIONS);

  export const listLockedInstallationsSuccess = createAction(
    Type.LIST_LOCKED_INSTALLATIONS_SUCCESS,
    props<{
      lockedInstallations: Installation[];
    }>()
  );

  export const listLockedInstallationsError = createAction(
    Type.LIST_LOCKED_INSTALLATIONS_ERROR,
    props<{ error: any }>()
  );

  export const removeInstallation = createAction(
    Type.REMOVE_INSTALLATION,
    props<{
      installationId: number;
    }>()
  );

  export const deregisterInstallation = createAction(
    Type.DEREGISTER_INSTALLATION,
    props<{
      installationId: number;
    }>()
  );

  export const deregisterInstallationSuccess = createAction(
    Type.DEREGISTER_INSTALLATION_SUCCESS,
    props<{
      installationId: number;
    }>()
  );

  export const resetDeregisterState = createAction(Type.RESET_DEREGISTER_STATE);

  export const deregisterInstallationError = createAction(Type.DEREGISTER_INSTALLATION_ERROR);

  export const liveUpdateAggregatedStatus = createAction(
    Type.LIVE_UPDATE_AGGREGATED_STATUS,
    props<{
      aggregatedStatus: AggregatedStatus;
      lastChangedAt: string;
      gatewaySerial: string;
    }>()
  );

  export const omitLoadingRemoteServiceSummaries = createAction(
    Type.OMIT_LOADING_REMOTE_SERVICE_SUMMARIES
  );

  export const fetchNumberOfDisplayedInstallations = createActionGroup({
    source: 'INSTALLATIONS Fetch Number Of Displayed Installations',
    events: {
      attempt: emptyProps(),
      success: props<{ numberOfInstallationsToDisplay: number }>(),
      failed: emptyProps(),
    },
  });

  export const setNumberOfDisplayedInstallations = createActionGroup({
    source: 'INSTALLATIONS Set Number Of Displayed Installations',
    events: {
      attempt: props<{ numberOfInstallationsToDisplay: number }>(),
      success: props<{ numberOfInstallationsToDisplay: number }>(),
      failed: props<{ previousNumberOfInstallationsToDisplay: number }>(),
    },
  });
}
